import useTracksStore, {
  SOUND_DESIGN_TRACK_ID,
  TrackType,
} from '../../../../../shared/store/tracks.store.tsx'
import useMediaStore from '../../../../../shared/store/media.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import type {
  AudioFormClip,
  SoundDesignAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { mapAudioFormClipToClipPositions } from './map-audio-form-clip-to-clip-positions.ts'
import { reduceAudioBufferVolume } from '@/utils/reduce-audiobuffer-volume.ts'

export const mapSoundDesignLayerToClips = async (
  asset: SoundDesignAsset,
  clip: AudioFormClip
): Promise<void> => {
  // Load asset into media store
  const { addMedia } = useMediaStore.getState()
  if (!asset.uri) return
  const originalAudioBuffer = await getAudioBufferFromAudioUrl(asset.uri)
  const audioBuffer = reduceAudioBufferVolume(originalAudioBuffer)
  addMedia(clip.assetRef, audioBuffer)

  // Load clip into tracks store
  const { addClip } = useTracksStore.getState()

  addClip(SOUND_DESIGN_TRACK_ID, {
    id: clip.assetRef,
    type: TrackType.SoundDesigns,
    trackId: SOUND_DESIGN_TRACK_ID,
    name: asset.soundTemplateAlias,
    mediaId: clip.assetRef,
    src: asset.uri,
    ...mapAudioFormClipToClipPositions(clip, audioBuffer.duration),
  })
}
